module.exports = __webpack_public_path__ + "v294910/img/sale-tag.da134e41.png";